var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{pre:true,attrs:{"d":"M12 3.6 4 10.4V19a1.5 1.5 0 0 0 1.5 1.5h4v-5a2.5 2.5 0 0 1 5 0v5h4A1.5 1.5 0 0 0 20 19v-8.6Z","stroke":"currentColor","stroke-width":"1.5","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }